import React from "react";
import { Container, Typography, Box } from "@mui/material";
import { useLang } from "../context/LangContext";
import locales from "../locales.json";

const FAQ = () => {
  const { lang } = useLang();
  const { FAQ_page } = locales;

  return (
    <Container
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: { xs: "center", md: "flex-start" }, // Centre sur mobile
        paddingTop: { xs: "32px", md: "50px" }, // Moins de padding sur mobile
        textAlign: { xs: "center", md: "left" }, // Centre sur mobile
        maxWidth: { xs: "100%", md: "800px" }, // 100% sur mobile, 800px sur desktop
        width: "100%",
        px: { xs: 2, md: 0 }, // Padding horizontal sur mobile
        boxSizing: "border-box",
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontWeight: "bold",
          marginBottom: "30px",
          fontSize: { xs: "2rem", md: "2.5rem" }, // Taille adaptée
          wordBreak: "break-word",
        }}
      >
        {FAQ_page.title[lang]}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          marginBottom: "20px",
          fontSize: { xs: "1rem", md: "1.1rem" },
          wordBreak: "break-word",
        }}
      >
        {FAQ_page.description[lang]}
      </Typography>
      <Box sx={{ marginBottom: "30px", width: "100%" }}>
        {FAQ_page.questions.map((question, index) => (
          <Box key={index} sx={{ marginBottom: "20px", width: "100%" }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                fontSize: { xs: "1.2rem", md: "1.5rem" },
                marginBottom: "8px",
                wordBreak: "break-word",
              }}
            >
              {question.question[lang]}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: "1rem", md: "1.1rem" },
                wordBreak: "break-word",
              }}
            >
              {question.answer[lang]}
            </Typography>
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default FAQ;
